import React from "react";
import { Loading } from "go-core/components/Loading";
import { MenuProvider } from "../../../../../../../../../../../services/Api/Organization/types";
import MenuExternalPortalOption from "./MenuExternalPortalOption";

interface Props {
	providers?: MenuProvider[];
	selectedProvider?: MenuProvider;
	setSelectedProvider: React.Dispatch<React.SetStateAction<MenuProvider | undefined>>;
}

const MenuExternalPortalOptions = ({ providers, setSelectedProvider, selectedProvider }: Props) => {
	if (!providers) return <Loading />;

	return (
		<div className="d-flex align-items-center gap-2 overflow-x-auto pb-3 mb-4 external-provider-options">
			{providers.map((provider) => (
				<MenuExternalPortalOption
					key={provider}
					provider={provider}
					selected={selectedProvider === provider}
					setSelectedProvider={setSelectedProvider}
				/>
			))}
		</div>
	);
};

export default MenuExternalPortalOptions;
